import React from "react";

const ACCompressorRepair = () => {
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold">AC Compressor Repair</h1>
      <p className="mt-4">
        Compressor faults can cause serious cooling failures — our team
        inspects, repairs, and replaces compressors with tested parts.
      </p>
    </div>
  );
};

export default ACCompressorRepair;

